import React from 'react';
// import { useState } from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';
// TextField
// import Grid from '@mui/material/Grid';
// import FormControl from '@mui/material/FormControl';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
// import Button from '@mui/material/Button';
// import Autocomplete from '@mui/material/Autocomplete';
// import MenuItem from '@mui/material/MenuItem';
// import FormHelperText from '@mui/material/FormHelperText';
// import Select from '@mui/material/Select';

import AddBuilderBranchForm from '../Components/AddBuilderBranchForm';

export default function AddBuilderBranchPage() {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Container>
            <AddBuilderBranchForm/>
        </Container>
    </Box>
  )
}
